<script setup lang="ts">
import { defineEmits, defineProps } from "vue";
import commonProps from "../props/commonProps";

export interface TextInputFormatter {
  format: (value: string) => string;
}

const props = defineProps({
  ...commonProps,
  textInputFormatters: {
    type: Array as () => TextInputFormatter[],
    default: () => [],
  },
});

const emit = defineEmits(["update:modelValue"]);

const applyFormatters = (value: string) => {
  return props.textInputFormatters.reduce((formattedValue, formatter) => {
    return formatter.format(formattedValue);
  }, value);
};

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  let value = target.value;
  const maxAttr = target.getAttribute("maxlength");
  const maxLength = maxAttr ? Number(maxAttr) : target.maxLength;
  if (maxLength > 0 && value.length > maxLength) {
    value = value.slice(0, maxLength);
    target.value = value;
  }
  const formattedValue = applyFormatters(value);
  emit("update:modelValue", formattedValue);
};
</script>

<template>
  <div>
    <label v-if="$attrs.label" :class="{ required: $attrs.required }">
      {{ $attrs.label }}
    </label>
    <input
      class="form-control"
      :value="modelValue"
      v-bind="$attrs"
      @input="handleInput"
      :type="type"
    />
  </div>
</template>
